import { ActivePlanningContainer } from '@/features/decisions/components/active-planning/ActivePlanningContainer';

export function ActivePlanning() {
  return <ActivePlanningContainer />;
}
